import { RouteType } from 'components/Header/Header.types';

const routes: RouteType[] = [
  {
    link: '/',
    label: 'svg',
    admin: true,
  },
  {
    link: '/directory',
    label: 'Directory',
    admin: false,
  },
  {
    link: '/membership',
    label: 'Membership',
    admin: false,
  },
  {
    link: '/benefits',
    label: 'Benefits',
    admin: false,
    group: [
      {
        label: 'Shipping Leads',
        link: '/benefits/shipping-leads',
      },
      {
        label: 'Networking',
        link: '/benefits/networking',
      },
      {
        label: 'Support',
        link: '/benefits/support',
      },
      {
        label: 'Brand Reliability',
        link: '/benefits/brand-reliability',
      },
      {
        label: 'Global Freight Forwarders List & Directory',
        link: '/benefits/member-directory',
      },
    ],
  },
  {
    link: '/digital-tools',
    label: 'Digital Tools',
    admin: false,
    group: [
      {
        label: 'Logistics Explorer',
        link: '/digital-tools/logistics-explorer',
      },
      {
        label: 'Tracking System',
        link: '/digital-tools/tracking-system',
      },
      {
        label: 'Ship Schedules',
        link: '/digital-tools/ship-schedules',
      },
      // {
      //   label: 'Cargoes Flow',
      //   link: '/digital-tools/cargoes-flow',
      // },
    ],
  },
  {
    link: '/resources',
    label: 'Resources',
    admin: false,
    group: [
      {
        label: 'How to become a Freight Forwarder',
        link: '/freight-forwarder',
      },
      {
        label: 'Freight Dictionary',
        link: '/freight-dictionary',
      },
      {
        label: 'Bill of Lading',
        link: '/resources/bill-of-lading',
      },
      {
        label: 'Freight Templates',
        link: '/resources/freight-templates',
      },
      {
        label: 'Demurrage and Detention',
        link: '/resources/demurrage-and-detention',
      },
      {
        label: 'Blog',
        link: '/blog',
      },
    ],
  },
  {
    link: '/events',
    label: 'Events',
    admin: false,
    group: [
      {
        label: 'Monthly Members Meeting',
        link: '/events/members-meeting',
      },
      {
        label: 'Global Freight Summit 2024',
        link: '/events/global-freight-summit',
      },
      {
        label: 'Digitalization and Future of Freight Conference',
        link: '/events/future-of-freight',
      },
      {
        label: 'Annual Conference',
        link: '/events/1st-dfa-annual-conference',
      },
      {
        label: 'Show all',
        link: '/events',
      },
    ],
  },
  {
    link: '/company/vision-strategy',
    label: 'Company',
    admin: false,
    group: [
      {
        label: 'Vision & Strategy',
        link: '/company/vision-strategy',
      },
      {
        label: 'Contact Us',
        link: '/company/contact-us',
      },
      {
        label: 'Membership Regulations',
        link: '/company/membership-regulations',
      },
      {
        label: 'Code of Ethics',
        link: '/company/code-of-ethics',
      },
      {
        label: 'FAQs',
        link: '/company/faqs',
      },
      // {
      //   label: 'Blacklist',
      //   link: '/company/blacklist',
      // },
    ],
  },
];

export default routes;
